import { render, staticRenderFns } from "./BirthdayForm.vue?vue&type=template&id=35c6dd4f&scoped=true"
import script from "./BirthdayForm.vue?vue&type=script&lang=js"
export * from "./BirthdayForm.vue?vue&type=script&lang=js"
import style0 from "./BirthdayForm.vue?vue&type=style&index=0&id=35c6dd4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6dd4f",
  null
  
)

export default component.exports